import "slick-carousel/slick/slick.scss";
import "slick-carousel/slick/slick-theme.scss";
import 'slick-carousel';

import '../stylesheets/application_admin_articles';
import '../stylesheets/sp';

import 'magnific-popup';
import './popup';
